import { Environment } from '../environments/environment'
import { LocaleId } from '../models'

type Link = string
type LinkLocalized = Record<LocaleId, Link>

interface LinkConfig {
  accessibilityStatement: LinkLocalized
  rentYourOwnHolidayWeek: LinkLocalized
  store: LinkLocalized
  storeServices: Link
  termsOfBookings: LinkLocalized
  termsOfDigitalServices: Link
  termsOfOwnership: Link
  termsOfRental: Link
  webshop: Link
  webshopSignUpComplete: Link
  welcomePresentation: Link
}

export const LINK_CONFIG: LinkConfig = {
  accessibilityStatement: {
    [LocaleId.EnUS]: `${Environment.API.Webshop.url}/en/footermenu/our-web-service/accessibility-statement/`,
    [LocaleId.Fi]: `${Environment.API.Webshop.url}/fi/footermenu/verkkopalvelustamme/saavutettavuusseloste-omat-lomasivut/`,
  },
  rentYourOwnHolidayWeek: {
    [LocaleId.EnUS]: `${Environment.API.Webshop.url}/en/ownership/viikko-osake/renting-out/`,
    [LocaleId.Fi]: `${Environment.API.Webshop.url}/fi/omistaminen/viikko-osake/vuokravalitys#lomakkeet`,
  },
  store: {
    [LocaleId.EnUS]: `${Environment.API.Webshop.url}/en/store`,
    [LocaleId.Fi]: `${Environment.API.Webshop.url}/fi/store/?`,
  },
  storeServices: `${Environment.API.Webshop.url}/fi/store/lisapalvelut-uusi/lista`,
  termsOfBookings: {
    [LocaleId.EnUS]: `${Environment.API.Webshop.url}/en/booking-terms-and-conditions/terms-and-conditions/`,
    [LocaleId.Fi]: `${Environment.API.Webshop.url}/fi/varausehdot/yhdistetyt-ehdot/`,
  },
  termsOfDigitalServices: `${Environment.API.Webshop.url}/fi/footermenu/verkkopalvelustamme/digitaalisten-palveluiden-kayttoehdot/`,
  termsOfOwnership: `${Environment.API.Webshop.url}/fi/omistaminen/omistajien-digipalvelut/`,
  termsOfRental: `${Environment.API.Webshop.url}/fi/omistaminen/viikko-osake/vuokravalitys/`,
  webshop: Environment.API.Webshop.url,
  webshopSignUpComplete: `${Environment.API.Webshop.url}/fi/sign-up-complete/`,
  welcomePresentation: `${Environment.API.Webshop.url}/fi/omistaminen/tervetuloa-esittelyyn/`,
}
